/**
 * @generated SignedSource<<b8dd63fd463007fe5dc213a05c342936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewAddress_answer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShallowAnswerPreview_answer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerAddress",
  "abstractKey": null
};
})();

node.hash = "fd10cba33bfe3df46cb5855f2d2d3314";

module.exports = node;
